module.exports = __webpack_public_path__ + "media/images/category/dummy/bottoms01-62c326dbe2ba42ca6f029b5fc444d1ce.jpg";